<template>
  <div class="component-container">
    <button @click.prevent="batchAddDistricts">Batch Add Districts - if you see this Do NOT Click - tell Michelle</button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
const fb = require('./../../firebase/firebase')

export default {
  data() {
    return {
      tempCode: '',
      districts: [
 {
   "districtCode": "EGPIYF",
   "districtName": "Adrian Public Schools",
   "districtCity": "Adrian",
   "districtState": "MI"
 },
 {
   "districtCode": "TDVPYW",
   "districtName": "Air Zoo Aerospace & Science Center",
   "districtCity": "Portage",
   "districtState": "MI"
 },
 {
   "districtCode": "HVQBGG",
   "districtName": "Airport Community School District",
   "districtCity": "Carleton",
   "districtState": "MI"
 },
 {
   "districtCode": "NDOJUP",
   "districtName": "All Saints Academy",
   "districtCity": "Grand Rapids",
   "districtState": "MI"
 },
 {
   "districtCode": "YGIHQS",
   "districtName": "Allegan Isd",
   "districtCity": "Allegan",
   "districtState": "MI"
 },
 {
   "districtCode": "MTFJXP",
   "districtName": "Allegan Public Schools",
   "districtCity": "Allegan",
   "districtState": "MI"
 },
 {
   "districtCode": "ZPKXEA",
   "districtName": "Almont Community Schools",
   "districtCity": "Almont",
   "districtState": "MI"
 },
 {
   "districtCode": "CXKJRE",
   "districtName": "Assumption of the Blessed Virgin Mary Sch",
   "districtCity": "Belmont",
   "districtState": "MI"
 },
 {
   "districtCode": "WYQHFK",
   "districtName": "Athens Area Schools",
   "districtCity": "East Leroy",
   "districtState": "MI"
 },
 {
   "districtCode": "TZAYMU",
   "districtName": "Bad Axe Public Schools",
   "districtCity": "Bad Axe",
   "districtState": "MI"
 },
 {
   "districtCode": "HZXGFP",
   "districtName": "Baker, Karen",
   "districtCity": "Kalamazoo",
   "districtState": "MI"
 },
 {
   "districtCode": "FZLAGQ",
   "districtName": "Baldwin Community Schools",
   "districtCity": "Baldwin",
   "districtState": "MI"
 },
 {
   "districtCode": "RQMEUU",
   "districtName": "Bangor Public Schools (Van Buren)",
   "districtCity": "Bangor",
   "districtState": "MI"
 },
 {
   "districtCode": "AHLUXI",
   "districtName": "Battle Creek Area Catholic Schools",
   "districtCity": "Battle Creek",
   "districtState": "MI"
 },
 {
   "districtCode": "MYPFAY",
   "districtName": "Battle Creek Mathematics & Science Center",
   "districtCity": "Battle Creek",
   "districtState": "MI"
 },
 {
   "districtCode": "JGANQT",
   "districtName": "Battle Creek Montessori Academy",
   "districtCity": "Springfield",
   "districtState": "MI"
 },
 {
   "districtCode": "ARKDNO",
   "districtName": "Battle Creek Public Schools",
   "districtCity": "Battle Creek",
   "districtState": "MI"
 },
 {
   "districtCode": "DJYUYP",
   "districtName": "Bay City Public Schools",
   "districtCity": "Bay City",
   "districtState": "MI"
 },
 {
   "districtCode": "GRNPXT",
   "districtName": "Beal City Public Schools",
   "districtCity": "Mt Pleasant",
   "districtState": "MI"
 },
 {
   "districtCode": "SCQAFS",
   "districtName": "Bedford Public Schools",
   "districtCity": "Temperance",
   "districtState": "MI"
 },
 {
   "districtCode": "TABWDG",
   "districtName": "Bellevue Comm School District",
   "districtCity": "Bellevue",
   "districtState": "MI"
 },
 {
   "districtCode": "ZCMJEG",
   "districtName": "Bentley Community School District",
   "districtCity": "Burton",
   "districtState": "MI"
 },
 {
   "districtCode": "OKTGFY",
   "districtName": "Berkley School District",
   "districtCity": "Oak Park",
   "districtState": "MI"
 },
 {
   "districtCode": "PTVORV",
   "districtName": "Big Rapids Public Schools",
   "districtCity": "Big Rapids",
   "districtState": "MI"
 },
 {
   "districtCode": "KAOISR",
   "districtName": "Blessed Sacrament School",
   "districtCity": "Midland",
   "districtState": "MI"
 },
 {
   "districtCode": "PULIZH",
   "districtName": "Bloomingdale Public School District",
   "districtCity": "Bloomingdale",
   "districtState": "MI"
 },
 {
   "districtCode": "JFVSAS",
   "districtName": "Bridgman Public Schools",
   "districtCity": "Bridgman",
   "districtState": "MI"
 },
 {
   "districtCode": "WFHBAW",
   "districtName": "Brown City Comm School District",
   "districtCity": "Brown City",
   "districtState": "MI"
 },
 {
   "districtCode": "SDWRGC",
   "districtName": "Buchanan Community School District",
   "districtCity": "Buchanan",
   "districtState": "MI"
 },
 {
   "districtCode": "JJZRSZ",
   "districtName": "Byron Center Christian Sch.",
   "districtCity": "Byron Center",
   "districtState": "MI"
 },
 {
   "districtCode": "DYEONW",
   "districtName": "Caledonia Community Schools",
   "districtCity": "Caledonia",
   "districtState": "MI"
 },
 {
   "districtCode": "PGNDJK",
   "districtName": "Calhoun Christian School",
   "districtCity": "Battle Creek",
   "districtState": "MI"
 },
 {
   "districtCode": "OMYDCB",
   "districtName": "Calhoun Isd",
   "districtCity": "Marshall",
   "districtState": "MI"
 },
 {
   "districtCode": "QAIXLO",
   "districtName": "Career Academy South Bend",
   "districtCity": "South Bend",
   "districtState": "IN"
 },
 {
   "districtCode": "IIAIEF",
   "districtName": "Caro Community Schools",
   "districtCity": "Caro",
   "districtState": "MI"
 },
 {
   "districtCode": "VUQUGW",
   "districtName": "Carrollton School District",
   "districtCity": "Carrollton",
   "districtState": "MI"
 },
 {
   "districtCode": "WETFAW",
   "districtName": "Caseville Public Schools",
   "districtCity": "Caseville",
   "districtState": "MI"
 },
 {
   "districtCode": "DLITOS",
   "districtName": "Cass City Public Schools",
   "districtCity": "Cass City",
   "districtState": "MI"
 },
 {
   "districtCode": "DDBDWY",
   "districtName": "Centreville Public Schools",
   "districtCity": "Centreville",
   "districtState": "MI"
 },
 {
   "districtCode": "QHNGPV",
   "districtName": "Chandler Park Academy",
   "districtCity": "Harper Woods",
   "districtState": "MI"
 },
 {
   "districtCode": "YJKGLE",
   "districtName": "Chelsea School District",
   "districtCity": "Chelsea",
   "districtState": "MI"
 },
 {
   "districtCode": "FQJRWB",
   "districtName": "Coldwater Community Schools",
   "districtCity": "Coldwater",
   "districtState": "MI"
 },
 {
   "districtCode": "DDYHRB",
   "districtName": "Columbia School District",
   "districtCity": "Brooklyn",
   "districtState": "MI"
 },
 {
   "districtCode": "FNRYIE",
   "districtName": "Concord Community School",
   "districtCity": "Concord",
   "districtState": "MI"
 },
 {
   "districtCode": "KYJVSR",
   "districtName": "Concord Community Schools",
   "districtCity": "Jackson",
   "districtState": "MI"
 },
 {
   "districtCode": "SVRAIH",
   "districtName": "Covenant Christian School",
   "districtCity": "Mishawaka",
   "districtState": "IN"
 },
 {
   "districtCode": "OVIVQQ",
   "districtName": "Covert Public Schools",
   "districtCity": "Covert",
   "districtState": "MI"
 },
 {
   "districtCode": "FLCMZO",
   "districtName": "Cross Lutheran School",
   "districtCity": "Pigeon",
   "districtState": "MI"
 },
 {
   "districtCode": "ZNTFGI",
   "districtName": "Dansville Agricultural Schools",
   "districtCity": "Mason",
   "districtState": "MI"
 },
 {
   "districtCode": "WSUQXB",
   "districtName": "Dansville Schools",
   "districtCity": "Dansville",
   "districtState": "MI"
 },
 {
   "districtCode": "KXOQVA",
   "districtName": "Delton Kellogg School District",
   "districtCity": "Delton",
   "districtState": "MI"
 },
 {
   "districtCode": "ZUXFMI",
   "districtName": "Dutton Christian School",
   "districtCity": "Caledonia",
   "districtState": "MI"
 },
 {
   "districtCode": "HBPWIQ",
   "districtName": "East Grand Rapids Public Schools",
   "districtCity": "Grand Rapids",
   "districtState": "MI"
 },
 {
   "districtCode": "VZUEQD",
   "districtName": "East Martin Christian School",
   "districtCity": "Martin",
   "districtState": "MI"
 },
 {
   "districtCode": "SWFWAO",
   "districtName": "Eastern Upper Peninsula ISD",
   "districtCity": "Sault Ste. Marie",
   "districtState": "MI"
 },
 {
   "districtCode": "PZMPYS",
   "districtName": "Eaton Rapids Public Schools",
   "districtCity": "Eaton Rapids",
   "districtState": "MI"
 },
 {
   "districtCode": "OKEQNF",
   "districtName": "Edwardsburg Public Schools",
   "districtCity": "Edwardsburg",
   "districtState": "MI"
 },
 {
   "districtCode": "GYBBEI",
   "districtName": "El-majj Malik El-shabazz Academy",
   "districtCity": "Lansing",
   "districtState": "MI"
 },
 {
   "districtCode": "BDOPEO",
   "districtName": "Elkton-Pigeon-Bay Port-Laker Schools",
   "districtCity": "Pigeon",
   "districtState": "MI"
 },
 {
   "districtCode": "FNWJPP",
   "districtName": "Engadine Consolidated Schools",
   "districtCity": "Engadine",
   "districtState": "MI"
 },
 {
   "districtCode": "PDCPGP",
   "districtName": "Essexville Hampton School District",
   "districtCity": "Essexville",
   "districtState": "MI"
 },
 {
   "districtCode": "UIYEQG",
   "districtName": "Farmington Public School District",
   "districtCity": "Farmington",
   "districtState": "MI"
 },
 {
   "districtCode": "WHGIBB",
   "districtName": "Fennville Public Schools",
   "districtCity": "Fennville",
   "districtState": "MI"
 },
 {
   "districtCode": "HEJKHT",
   "districtName": "Ferndale Public Schools",
   "districtCity": "Ferndale",
   "districtState": "MI"
 },
 {
   "districtCode": "MIEIEO",
   "districtName": "Fitzgerald Public Schools",
   "districtCity": "Warren",
   "districtState": "MI"
 },
 {
   "districtCode": "YPEBCC",
   "districtName": "Forest Hills Public Schools",
   "districtCity": "Grand Rapids",
   "districtState": "MI"
 },
 {
   "districtCode": "IYIHCK",
   "districtName": "Fowlerville Community Schools",
   "districtCity": "Fowlerville",
   "districtState": "MI"
 },
 {
   "districtCode": "MLRWMS",
   "districtName": "Fraser Public Schools",
   "districtCity": "Fraser",
   "districtState": "MI"
 },
 {
   "districtCode": "KUDAVK",
   "districtName": "Freeland Comm School District",
   "districtCity": "Freeland",
   "districtState": "MI"
 },
 {
   "districtCode": "ORYFQS",
   "districtName": "Fremont Christian School",
   "districtCity": "Fremont",
   "districtState": "MI"
 },
 {
   "districtCode": "FINTWF",
   "districtName": "Godwin Heights Public Schools",
   "districtCity": "Wyoming",
   "districtState": "MI"
 },
 {
   "districtCode": "ABCZRB",
   "districtName": "Grand Haven Christian School",
   "districtCity": "Grand Haven",
   "districtState": "MI"
 },
 {
   "districtCode": "MUKOQD",
   "districtName": "Grand Ledge Public Schools",
   "districtCity": "Grand Ledge",
   "districtState": "MI"
 },
 {
   "districtCode": "IXMWJD",
   "districtName": "Grand Rapids Christian School",
   "districtCity": "Grand Rapids",
   "districtState": "MI"
 },
 {
   "districtCode": "OFDMSA",
   "districtName": "Greenville Public Schools",
   "districtCity": "Greenville",
   "districtState": "MI"
 },
 {
   "districtCode": "XYQNYH",
   "districtName": "Grosse Pointe Public Schools",
   "districtCity": "Grosse Pointe",
   "districtState": "MI"
 },
 {
   "districtCode": "LQTZWL",
   "districtName": "Gull Lake Community Schools",
   "districtCity": "Richland",
   "districtState": "MI"
 },
 {
   "districtCode": "CLHHGG",
   "districtName": "Hanover Horton Schools",
   "districtCity": "Hanover",
   "districtState": "MI"
 },
 {
   "districtCode": "UMUVFA",
   "districtName": "Harbor Beach Community Schools",
   "districtCity": "Harbor Beach",
   "districtState": "MI"
 },
 {
   "districtCode": "WFXWBM",
   "districtName": "Harper Creek Community Schools",
   "districtCity": "Battle Creek",
   "districtState": "MI"
 },
 {
   "districtCode": "RKQRJR",
   "districtName": "Hart Public School District",
   "districtCity": "Hart",
   "districtState": "MI"
 },
 {
   "districtCode": "QJPFDG",
   "districtName": "Hemlock Public School District",
   "districtCity": "Hemlock",
   "districtState": "MI"
 },
 {
   "districtCode": "QCIGEK",
   "districtName": "Hesperia Community Schools",
   "districtCity": "Hesperia",
   "districtState": "MI"
 },
 {
   "districtCode": "XKJTFA",
   "districtName": "Hillsdale Community Schools",
   "districtCity": "Hillsdale",
   "districtState": "MI"
 },
 {
   "districtCode": "WIGKXG",
   "districtName": "Holland Public Schools",
   "districtCity": "Holland",
   "districtState": "MI"
 },
 {
   "districtCode": "FQFPGO",
   "districtName": "Holly Area School District",
   "districtCity": "Holly",
   "districtState": "MI"
 },
 {
   "districtCode": "VJNLRD",
   "districtName": "Holt Public Schools",
   "districtCity": "Holt",
   "districtState": "MI"
 },
 {
   "districtCode": "QMELQK",
   "districtName": "Holton Public Schools",
   "districtCity": "Holton",
   "districtState": "MI"
 },
 {
   "districtCode": "YJPSPV",
   "districtName": "Homer Community Schools",
   "districtCity": "Homer",
   "districtState": "MI"
 },
 {
   "districtCode": "XFKVDR",
   "districtName": "Hopkins Public Schools",
   "districtCity": "Hopkins",
   "districtState": "MI"
 },
 {
   "districtCode": "URQSIB",
   "districtName": "Howell Public Schools",
   "districtCity": "Howell",
   "districtState": "MI"
 },
 {
   "districtCode": "PXDSUW",
   "districtName": "Hudson Area Schools",
   "districtCity": "Hudson",
   "districtState": "MI"
 },
 {
   "districtCode": "LHHXKQ",
   "districtName": "Hudsonville Christian School",
   "districtCity": "Hudsonville",
   "districtState": "MI"
 },
 {
   "districtCode": "BQILTE",
   "districtName": "Innocademy Allegan",
   "districtCity": "Fennville",
   "districtState": "MI"
 },
 {
   "districtCode": "LUAWRU",
   "districtName": "Island City Academy",
   "districtCity": "Eaton Rapids",
   "districtState": "MI"
 },
 {
   "districtCode": "DBKGGX",
   "districtName": "Jackson Public Schools",
   "districtCity": "Jackson",
   "districtState": "MI"
 },
 {
   "districtCode": "GFWIOO",
   "districtName": "Joy Preparatory Academy",
   "districtCity": "Detroit",
   "districtState": "MI"
 },
 {
   "districtCode": "JZJUEB",
   "districtName": "Kalamazoo Public School District",
   "districtCity": "Kalamazoo",
   "districtState": "MI"
 },
 {
   "districtCode": "UCDFYV",
   "districtName": "Kent City Community Schools",
   "districtCity": "Kent City",
   "districtState": "MI"
 },
 {
   "districtCode": "EXUXFV",
   "districtName": "L'Anse Creuse Public Schools",
   "districtCity": "Harrison Township",
   "districtState": "MI"
 },
 {
   "districtCode": "XVRZPH",
   "districtName": "Laingsburg Community School District",
   "districtCity": "Laingsburg",
   "districtState": "MI"
 },
 {
   "districtCode": "WOCZBD",
   "districtName": "Lake Fenton Schools",
   "districtCity": "Fenton",
   "districtState": "MI"
 },
 {
   "districtCode": "HDNDQL",
   "districtName": "Lake Superior State University",
   "districtCity": "Sault Ste. Marie",
   "districtState": "MI"
 },
 {
   "districtCode": "BNABRU",
   "districtName": "Lakeview Community Schools (Montcalm)",
   "districtCity": "Lakeview",
   "districtState": "MI"
 },
 {
   "districtCode": "WMJXPA",
   "districtName": "Lakeview School District (calhoun)",
   "districtCity": "Battle Creek",
   "districtState": "MI"
 },
 {
   "districtCode": "NGNUTW",
   "districtName": "Lawton Community School District",
   "districtCity": "Lawton",
   "districtState": "MI"
 },
 {
   "districtCode": "XCBTJB",
   "districtName": "Legacy Christian School",
   "districtCity": "Grand Rapids",
   "districtState": "MI"
 },
 {
   "districtCode": "NKNCFA",
   "districtName": "Les Cheneaux Community Schools",
   "districtCity": "Cedarville",
   "districtState": "MI"
 },
 {
   "districtCode": "IWKJPK",
   "districtName": "Lowell Area School District",
   "districtCity": "Lowell",
   "districtState": "MI"
 },
 {
   "districtCode": "PRGSAU",
   "districtName": "Ludington Area Catholic School",
   "districtCity": "Ludington",
   "districtState": "MI"
 },
 {
   "districtCode": "BPSRJO",
   "districtName": "Ludington Area School District",
   "districtCity": "Ludington",
   "districtState": "MI"
 },
 {
   "districtCode": "PCHAML",
   "districtName": "Manistee Area Public Schools",
   "districtCity": "Manistee",
   "districtState": "MI"
 },
 {
   "districtCode": "LBBNEK",
   "districtName": "Maple Valley School District",
   "districtCity": "Vermontville",
   "districtState": "MI"
 },
 {
   "districtCode": "JWDQOL",
   "districtName": "Mar Lee School District",
   "districtCity": "Marshall",
   "districtState": "MI"
 },
 {
   "districtCode": "TSEGQC",
   "districtName": "Marlette Community Schools",
   "districtCity": "Marlette",
   "districtState": "MI"
 },
 {
   "districtCode": "VILJZN",
   "districtName": "Marshall Academy",
   "districtCity": "Marshall",
   "districtState": "MI"
 },
 {
   "districtCode": "LFYQAI",
   "districtName": "Marshall Public Schools",
   "districtCity": "Marshall",
   "districtState": "MI"
 },
 {
   "districtCode": "UEQWUF",
   "districtName": "Martin Public Schools",
   "districtCity": "Martin",
   "districtState": "MI"
 },
 {
   "districtCode": "USWCUU",
   "districtName": "Mason County Central School Dist",
   "districtCity": "Scottville",
   "districtState": "MI"
 },
 {
   "districtCode": "VIYBUX",
   "districtName": "Mason County Eastern School Dist",
   "districtCity": "Custer",
   "districtState": "MI"
 },
 {
   "districtCode": "NZEQBG",
   "districtName": "Mason Public Schools",
   "districtCity": "Mason",
   "districtState": "MI"
 },
 {
   "districtCode": "MQNONA",
   "districtName": "Mason Public Schools (Ingham)",
   "districtCity": "Mason",
   "districtState": "MI"
 },
 {
   "districtCode": "QTWFOQ",
   "districtName": "Mattawan Consolidated School District",
   "districtCity": "Mattawan",
   "districtState": "MI"
 },
 {
   "districtCode": "WGKZZT",
   "districtName": "Mayville Community School District",
   "districtCity": "Mayville",
   "districtState": "MI"
 },
 {
   "districtCode": "YZLEUB",
   "districtName": "Mendon Community School District",
   "districtCity": "Mendon",
   "districtState": "MI"
 },
 {
   "districtCode": "SOQKDP",
   "districtName": "Menominee Area Public Schools",
   "districtCity": "Menominee",
   "districtState": "MI"
 },
 {
   "districtCode": "EYYMQE",
   "districtName": "Midland Public Schools",
   "districtCity": "Midland",
   "districtState": "MI"
 },
 {
   "districtCode": "RWVDFJ",
   "districtName": "Milan Area Schools",
   "districtCity": "Milan",
   "districtState": "MI"
 },
 {
   "districtCode": "LKLDSM",
   "districtName": "Moline Christian School",
   "districtCity": "Moline",
   "districtState": "MI"
 },
 {
   "districtCode": "YRXDMF",
   "districtName": "Mona Shores School District",
   "districtCity": "Norton Shores",
   "districtState": "MI"
 },
 {
   "districtCode": "BQYACP",
   "districtName": "Montague Area Public Schools",
   "districtCity": "Montague",
   "districtState": "MI"
 },
 {
   "districtCode": "BLHUHM",
   "districtName": "Montrose Community Schools",
   "districtCity": "Montrose",
   "districtState": "MI"
 },
 {
   "districtCode": "QVBNVK",
   "districtName": "Mt Morris Consolidated Schools",
   "districtCity": "Mt Morris",
   "districtState": "MI"
 },
 {
   "districtCode": "QDGHJK",
   "districtName": "Muskegon Area Intermed. School Dist.",
   "districtCity": "Muskegon",
   "districtState": "MI"
 },
 {
   "districtCode": "EMMCCP",
   "districtName": "Muskegon Christian School",
   "districtCity": "Muskegon",
   "districtState": "MI"
 },
 {
   "districtCode": "XOOLJE",
   "districtName": "Muskegon Public Schools",
   "districtCity": "Muskegon",
   "districtState": "MI"
 },
 {
   "districtCode": "TTRUXA",
   "districtName": "New Buffalo Area School District",
   "districtCity": "New Buffalo",
   "districtState": "MI"
 },
 {
   "districtCode": "DNDFHB",
   "districtName": "New Era Christian",
   "districtCity": "New Era",
   "districtState": "MI"
 },
 {
   "districtCode": "YRKAOI",
   "districtName": "North Muskegon Public Schs.",
   "districtCity": "North Muskegon",
   "districtState": "MI"
 },
 {
   "districtCode": "IUDHCY",
   "districtName": "NorthPointe Christian",
   "districtCity": "Grand Rapids",
   "districtState": "MI"
 },
 {
   "districtCode": "HPGVEU",
   "districtName": "Northport Public School District",
   "districtCity": "Northport",
   "districtState": "MI"
 },
 {
   "districtCode": "PMVKSI",
   "districtName": "Oakland University",
   "districtCity": "Rochester",
   "districtState": "MI"
 },
 {
   "districtCode": "YSFZFV",
   "districtName": "Oakridge Public Schools",
   "districtCity": "Muskegon",
   "districtState": "MI"
 },
 {
   "districtCode": "FIPGXV",
   "districtName": "Olivet Community Schools",
   "districtCity": "Olivet",
   "districtState": "MI"
 },
 {
   "districtCode": "SUAXRL",
   "districtName": "Orchard View School District",
   "districtCity": "Muskegon",
   "districtState": "MI"
 },
 {
   "districtCode": "ATZEGV",
   "districtName": "Otsego Public Schools",
   "districtCity": "Otsego",
   "districtState": "MI"
 },
 {
   "districtCode": "UCYUGP",
   "districtName": "Oxford Community School District",
   "districtCity": "Oxford",
   "districtState": "MI"
 },
 {
   "districtCode": "FIHQIC",
   "districtName": "Park Forest - Chicago Heights SD 163",
   "districtCity": "Park Forest",
   "districtState": "IL"
 },
 {
   "districtCode": "KKWWTH",
   "districtName": "Peace Lutheran School",
   "districtCity": "Saginaw",
   "districtState": "MI"
 },
 {
   "districtCode": "BIOPLJ",
   "districtName": "Peck Community School District",
   "districtCity": "Peck",
   "districtState": "MI"
 },
 {
   "districtCode": "DEVXNP",
   "districtName": "Pennfield School District",
   "districtCity": "Battle Creek",
   "districtState": "MI"
 },
 {
   "districtCode": "WGONXD",
   "districtName": "Pentwater Public School District",
   "districtCity": "Pentwater",
   "districtState": "MI"
 },
 {
   "districtCode": "HOMGHH",
   "districtName": "Pickford Public Schools",
   "districtCity": "Pickford",
   "districtState": "MI"
 },
 {
   "districtCode": "XKBYPD",
   "districtName": "Pinconning Area Schools",
   "districtCity": "Pinconning",
   "districtState": "MI"
 },
 {
   "districtCode": "WKMSFL",
   "districtName": "Plainwell Community Schools",
   "districtCity": "Plainwell",
   "districtState": "MI"
 },
 {
   "districtCode": "LYXIMN",
   "districtName": "Portland Public School District",
   "districtCity": "Portland",
   "districtState": "MI"
 },
 {
   "districtCode": "IMYQGM",
   "districtName": "Potterville Public Schools",
   "districtCity": "Potterville",
   "districtState": "MI"
 },
 {
   "districtCode": "CMGGMY",
   "districtName": "Quincy Community School District",
   "districtCity": "Quincy",
   "districtState": "MI"
 },
 {
   "districtCode": "PZAJJD",
   "districtName": "Ravena Public Schools",
   "districtCity": "Ravenna",
   "districtState": "MI"
 },
 {
   "districtCode": "CDUGUS",
   "districtName": "Reeths Puffer Schools",
   "districtCity": "Muskegon",
   "districtState": "MI"
 },
 {
   "districtCode": "RQBWJO",
   "districtName": "Reformed Heritage Christian School",
   "districtCity": "Kalamazoo",
   "districtState": "MI"
 },
 {
   "districtCode": "GHGAEO",
   "districtName": "Rochester Community School District",
   "districtCity": "Rochester",
   "districtState": "MI"
 },
 {
   "districtCode": "IVSFUV",
   "districtName": "Rockford Public Schools",
   "districtCity": "Rockford",
   "districtState": "MI"
 },
 {
   "districtCode": "ECFCFP",
   "districtName": "Royal Oak Public Schools",
   "districtCity": "Royal Oak",
   "districtState": "MI"
 },
 {
   "districtCode": "SEQOGX",
   "districtName": "Rudyard Area Schools",
   "districtCity": "Rudyard",
   "districtState": "MI"
 },
 {
   "districtCode": "EVJWIS",
   "districtName": "Saginaw Isd",
   "districtCity": "Saginaw",
   "districtState": "MI"
 },
 {
   "districtCode": "RZCVRV",
   "districtName": "Sand Creek Community Schools",
   "districtCity": "Sand Creek",
   "districtState": "MI"
 },
 {
   "districtCode": "ZMKGKV",
   "districtName": "Sanilac Isd",
   "districtCity": "Sandusky",
   "districtState": "MI"
 },
 {
   "districtCode": "ISSYGF",
   "districtName": "Sault Ste Marie Area Schools",
   "districtCity": "Sault Ste Marie",
   "districtState": "MI"
 },
 {
   "districtCode": "XXUNPT",
   "districtName": "Schoolcraft Community Schools",
   "districtCity": "Schoolcraft",
   "districtState": "MI"
 },
 {
   "districtCode": "BKPMPN",
   "districtName": "Shelby Public Schools",
   "districtCity": "Shelby",
   "districtState": "MI"
 },
 {
   "districtCode": "GWSSJG",
   "districtName": "Sodus Township School District #5",
   "districtCity": "Sodus",
   "districtState": "MI"
 },
 {
   "districtCode": "NRYCRO",
   "districtName": "South Haven Public Schools",
   "districtCity": "South Haven",
   "districtState": "MI"
 },
 {
   "districtCode": "VMVRPS",
   "districtName": "South Lyon Community Schools",
   "districtCity": "South Lyon",
   "districtState": "MI"
 },
 {
   "districtCode": "NEFVQR",
   "districtName": "Spring Lake Public Schools",
   "districtCity": "Holland",
   "districtState": "MI"
 },
 {
   "districtCode": "ZXQKMZ",
   "districtName": "St. Ignace Area Schools",
   "districtCity": "St Ignace",
   "districtState": "MI"
 },
 {
   "districtCode": "ZRYJSO",
   "districtName": "St. Joseph Public Schools",
   "districtCity": "St Joseph",
   "districtState": "MI"
 },
 {
   "districtCode": "SPJRWF",
   "districtName": "St. Joseph the Worker School",
   "districtCity": "Mt. Pleasant",
   "districtState": "MI"
 },
 {
   "districtCode": "MSXTBX",
   "districtName": "St. Louis Public Schools",
   "districtCity": "St Louis",
   "districtState": "MI"
 },
 {
   "districtCode": "ZMNNAA",
   "districtName": "St. Matthew Lutheran",
   "districtCity": "Walled Lake",
   "districtState": "MI"
 },
 {
   "districtCode": "VVMEJH",
   "districtName": "St. Michael",
   "districtCity": "Remus",
   "districtState": "MI"
 },
 {
   "districtCode": "LJURLN",
   "districtName": "St. Patrick Catholic School - Parnell",
   "districtCity": "Ada",
   "districtState": "MI"
 },
 {
   "districtCode": "GIQKNC",
   "districtName": "St. Patrick Catholic School - Portland",
   "districtCity": "Portland",
   "districtState": "MI"
 },
 {
   "districtCode": "TMFLBL",
   "districtName": "St. Thomas School",
   "districtCity": "Grand Rapids",
   "districtState": "MI"
 },
 {
   "districtCode": "XVXBKY",
   "districtName": "Summerfield School District",
   "districtCity": "Petersburg",
   "districtState": "MI"
 },
 {
   "districtCode": "XAGLDX",
   "districtName": "Summit Academy",
   "districtCity": "Flat Rock",
   "districtState": "MI"
 },
 {
   "districtCode": "XTFSDL",
   "districtName": "Tahquamenon Area Schools",
   "districtCity": "Newberry",
   "districtState": "MI"
 },
 {
   "districtCode": "NXYEEW",
   "districtName": "Tekonsha Community Schools",
   "districtCity": "Tekonsha",
   "districtState": "MI"
 },
 {
   "districtCode": "FCVZLE",
   "districtName": "Three Lakes Academy",
   "districtCity": "Curtis",
   "districtState": "MI"
 },
 {
   "districtCode": "WPMLNB",
   "districtName": "Three Rivers Community Schools",
   "districtCity": "Three Rivers",
   "districtState": "MI"
 },
 {
   "districtCode": "CCKRWS",
   "districtName": "Trenton Public Schools",
   "districtCity": "Trenton",
   "districtState": "MI"
 },
 {
   "districtCode": "UHJCVF",
   "districtName": "Tri County Area Schools",
   "districtCity": "Sand Lake",
   "districtState": "MI"
 },
 {
   "districtCode": "ZFONWM",
   "districtName": "Trinity Lutheran School - St. Joseph",
   "districtCity": "St Joseph",
   "districtState": "MI"
 },
 {
   "districtCode": "BVMPHW",
   "districtName": "Troy School District",
   "districtCity": "Troy",
   "districtState": "MI"
 },
 {
   "districtCode": "BAAMEK",
   "districtName": "Union City Community School District",
   "districtCity": "Union City",
   "districtState": "MI"
 },
 {
   "districtCode": "HQSIFY",
   "districtName": "Utica Community Schools",
   "districtCity": "Sterling Heights",
   "districtState": "MI"
 },
 {
   "districtCode": "NPRRRK",
   "districtName": "Van Buren Pub Schools",
   "districtCity": "Belleville",
   "districtState": "MI"
 },
 {
   "districtCode": "ITZDPR",
   "districtName": "Vicksburg Community Schools",
   "districtCity": "Vicksburg",
   "districtState": "MI"
 },
 {
   "districtCode": "XBEJKB",
   "districtName": "Walkerville Public Schools",
   "districtCity": "Walkerville",
   "districtState": "MI"
 },
 {
   "districtCode": "LLVSFO",
   "districtName": "Warren Consolidated Schools",
   "districtCity": "Warren",
   "districtState": "MI"
 },
 {
   "districtCode": "JRVKVL",
   "districtName": "Webberville Community Schools",
   "districtCity": "Webberville",
   "districtState": "MI"
 },
 {
   "districtCode": "LYRLVA",
   "districtName": "West Michigan Academy of Arts & Academics",
   "districtCity": "Spring Lake",
   "districtState": "MI"
 },
 {
   "districtCode": "GBRMQN",
   "districtName": "West Shore Educational Service Dist.",
   "districtCity": "Ludington",
   "districtState": "MI"
 },
 {
   "districtCode": "FDZVJX",
   "districtName": "Western Michigan Christian School",
   "districtCity": "Muskegon",
   "districtState": "MI"
 },
 {
   "districtCode": "TSYXPJ",
   "districtName": "Woodland Park Academy",
   "districtCity": "Grand Blanc",
   "districtState": "MI"
 },
 {
   "districtCode": "QNHVGM",
   "districtName": "Zion Lutheran School",
   "districtCity": "Harbor Beach",
   "districtState": "MI"
 }
]
    }
  },
  computed: {
    ...mapState([ 'userProfile' ])
  },
  methods: {
    batchAddDistricts() {
      this.districts.forEach((district) => {
        fb.districtsCollection.add({
          districtName: district.districtName,
          districtCity: district.districtCity,
          districtState: district.districtState,
          districtCode: district.districtCode,
          createdAt: new Date(),
          createdBy: this.userProfile.userId,
          active: true
        }).then(() => {
          console.log('District Added: ', district.districtName)
        }).catch((err) => {
          console.log(err)
        })
      })
    }
  }
}
</script>

<style lang="css" scoped>
</style>
